<app-overlay-spinner *ngIf="networkService.offlineOrLoading"></app-overlay-spinner>
<div class="air-quality-container">
  <ng-container *ngFor="let section of sectionList">
    <div class="accordion">
      <div class="accordion-header" (click)="toggleSection(section.key)">
        <h1>{{ section.title }}</h1>
      </div>
      <div class="accordion-content" [class.collapsed]="!isSectionOpen[section.key]">
        <!--
        <ng-container *ngIf="section.key === 'estm'">
          <section class="block-section estm-info">
            <p><strong>Projektpartner:</strong> Bosch</p>
            <p><strong>Art:</strong> Micro-Service (Cloud)</p>
            <p><strong>Kurzbeschreibung:</strong> Modellierung der Emissionen des Straßenverkehrs (CO₂, NOₓ, PM) basierend auf realen Fahrzeugbewegungsprofilen und aktuellen Verkehrsmengen. Die räumliche Auflösung beträgt 20 m, die zeitliche Auflösung 1 h.</p>

            <p><strong>Eingangssignale:</strong></p>
            <ul>
              <li><strong>HERE probe data</strong> (HERE technologies): Sekündlich aufgelöste Trajektorien vernetzter Fahrzeuge (FCD) – REST API (GET)</li>
              <li><strong>Verkehrsmengen</strong> (Kommunen): Dynamische Verkehrsdaten – Mengen und Zusammensetzung nach Fahrzeugklassen</li>
              <li><strong>Verkehrsflotte</strong> (Kommunen, KBA): Statische Zusammensetzung nach Fahrzeug- und Emissionsklassen</li>
              <li><strong>Straßennetz</strong> (Kommunen): Kartenmodell mit Straßenklassen, Steigungen und Geometrien</li>
            </ul>

            <p><strong>Ausgangssignal:</strong></p>
            <ul>
              <li><strong>estm</strong> (Bosch): Stündlich aktualisierte, aggregierte Verkehrsemissionen auf dem gesamten Streckennetz – REST API (GET)</li>
            </ul>
          </section>
        </ng-container>
        -->
        <!--
        <ng-container *ngIf="section.key === 'aqdm'">
          <section class="block-section aqdm-info">
            <p><strong>Projektpartner:</strong> Bosch</p>
            <p><strong>Art:</strong> Micro-Service (Cloud)</p>
            <p><strong>Kurzbeschreibung:</strong> Erstellung von 2D-Luftqualitätskarten basierend auf makroskopischen Emissionskarten (ESTM) und Luftqualitätssensorwerten. Die räumliche Auflösung beträgt bis zu 5 m, die zeitliche Auflösung 1 h.</p>

            <p><strong>Eingangssignale:</strong></p>
            <ul>
              <li><strong>estm</strong> (Bosch): Stündliche Emissionskarten – REST API (GET)</li>
              <li><strong>Luftqualitätsdaten</strong> (Bosch, UBA, …): Dynamische Messwerte der Luftqualität – REST API (GET)</li>
              <li><strong>Wetterdaten</strong> (meteomatics): Windgeschwindigkeit/-richtung, Temperatur, Stabilitätsklassen – REST API (GET)</li>
              <li><strong>Straßennetz</strong> (Kommunen): Knoten/Kanten-Modell mit Straßenklassen, Steigungen, Geometrien</li>
              <li><strong>3D Topologiekarte Gebäude</strong> (Kommunen): Gebäude mit Höhenangaben (LOD1), ggf. Vegetation</li>
              <li><strong>3D Topologiekarte Gelände:</strong> Höhenprofil des Gebiets</li>
            </ul>

            <p><strong>Ausgangssignal:</strong></p>
            <ul>
              <li><strong>aqdm</strong> (Bosch): Stündlich aktualisierte Luftqualitätskarten (2D) – REST API (GET)</li>
            </ul>
          </section>
        </ng-container>
        -->
        <ng-container *ngIf="section.key === 'overview'">
          <section class="block-section">
            <h2>Erklärungen zu Schadstoffen</h2>
            <section class="pollutants-info">
              <p><strong>Stickstoffdioxid (NO₂):</strong> NO₂ ist ein gasförmiger Luftschadstoff, der vor allem bei Verbrennungsprozessen (z. B. in Fahrzeugmotoren, Industrieanlagen) entsteht. Er reizt die Atemwege und trägt zur Feinstaub- und Ozonbildung bei.</p>
              <p><strong>Ozon (O₃):</strong> Ozon ist ein sekundärer Luftschadstoff, der durch Sonneneinstrahlung aus Stickoxiden (NOₓ) und flüchtigen organischen Verbindungen (VOCs) entsteht. In Bodennähe ist Ozon reizend für Atemwege, Augen und Pflanzen.</p>
              <p><strong>Feinstaub (PM₁₀ / PM₂,₅ / PM₁):</strong> Partikel mit verschiedenen aerodynamischem Durchmessern</p>
              <ul>
                <li><strong>PM₁₀ ≤ 10 µm:</strong> Diese Partikel können in die oberen Atemwege eindringen. Quellen: Straßenverkehr, Baustellen, Industrie, Holzheizungen.</li>
                <li><strong>PM₂,₅ ≤ 2,5 µm:</strong> Diese Partikel können bis in die Lungenbläschen und in den Blutkreislauf gelangen.</li>
                <li><strong>PM₁ ≤ 1 µm:</strong> Dies sind ultrafeine Partikel, die tief in den Körper eindringen können. Noch gibt es keine offiziellen Grenzwerte, diese sind aber in Diskussion.</li>
              </ul>
            </section>

            <section class="limits-table">
              <h3>Aktuelle und zukünftige Grenzwerte für Luftschadstoffe (Stand: April 2025)</h3>
              <table>
                <thead>
                  <tr>
                    <th>Schadstoff</th>
                    <th>Einheit</th>
                    <th>EU-Grenzwert (aktuell)</th>
                    <th>EU-Grenzwert (ab 2030)</th>
                    <th>WHO-Richtwert (2021)</th>
                    <th>Mittelungszeitraum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>NO (Stickstoffmonoxid)</td><td>µg/m³</td><td>-</td><td>-</td><td>-</td><td>-</td></tr>
                  <tr><td>NO₂ (Stickstoffdioxid)</td><td>µg/m³</td><td>40 (Jahresmittel)</td><td>20 (Jahresmittel)</td><td>10 (Jahresmittel)</td><td>1 Jahr</td></tr>
                  <tr><td></td><td>µg/m³</td><td>200 (1-Stunden-Mittelwert, max. 18 Überschreitungen/Jahr)</td><td>200 (1-Stunden-Mittelwert, max. 3 Überschreitungen/Jahr)</td><td>25 (24-Stunden-Mittelwert)</td><td>1 Stunde / 24 Stunden</td></tr>
                  <tr><td>O₃ (Ozon)</td><td>µg/m³</td><td>120 (8-Stunden-Mittelwert, Zielwert)</td><td>100 (8-Stunden-Mittelwert, Zielwert)</td><td>100 (8-Stunden-Mittelwert)</td><td>8 Stunden</td></tr>
                  <tr><td></td><td>µg/m³</td><td>180 (Informationsschwelle)</td><td>180 (Informationsschwelle)</td><td>60 (Spitzenwert Saisonmittel)</td><td>1 Stunde / Saisonmittel</td></tr>
                  <tr><td>PM₁₀</td><td>µg/m³</td><td>40 (Jahresmittel)</td><td>20 (Jahresmittel)</td><td>15 (Jahresmittel)</td><td>1 Jahr</td></tr>
                  <tr><td></td><td>µg/m³</td><td>50 (Tagesmittel, max. 35 Überschreitungen/Jahr)</td><td>45 (Tagesmittel, max. 18 Überschreitungen/Jahr)</td><td>45 (24-Stunden-Mittelwert)</td><td>24 Stunden</td></tr>
                  <tr><td>PM₂.₅</td><td>µg/m³</td><td>25 (Jahresmittel)</td><td>10 (Jahresmittel)</td><td>5 (Jahresmittel)</td><td>1 Jahr</td></tr>
                  <tr><td></td><td>µg/m³</td><td>-</td><td>25 (Tagesmittel, max. 18 Überschreitungen/Jahr)</td><td>15 (24-Stunden-Mittelwert)</td><td>24 Stunden</td></tr>
                  <tr><td>PM₁</td><td>µg/m³</td><td>-</td><td>-</td><td>-</td><td>-</td></tr>
                </tbody>
              </table>
            </section>

            <section class="note">
              <h4>Hinweise</h4>
              <p>Die EU-Grenzwerte basieren auf der Richtlinie 2008/50/EG und der überarbeiteten Richtlinie 2024/2881, die am 10. Dezember 2024 in Kraft getreten ist. Die neuen Grenzwerte sind bis zum 1. Januar 2030 zu erreichen.</p>
              <p>Die WHO-Richtwerte wurden 2021 aktualisiert und dienen als Empfehlung für den Schutz der menschlichen Gesundheit.</p>
            </section>

            <section class="additional-info">
              <h3>Erläuterungen zu NO und PM₁</h3>
              <ul>
                <li><strong>Stickstoffmonoxid (NO)</strong>
                  <ul>
                    <li><strong>EU-Grenzwerte:</strong> Die EU legt keine eigenständigen Grenzwerte für NO fest, sondern konzentriert sich auf NO₂, da dieses als stabilerer Indikator für die gesundheitlichen Auswirkungen von Stickstoffoxiden gilt.</li>
                    <li><strong>WHO-Richtlinien:</strong> Die WHO hat ebenfalls keine spezifischen Richtlinien für NO, sondern empfiehlt für NO₂:
                      <ul>
                        <li>10 µg/m³ als Jahresmittelwert</li>
                        <li>25 µg/m³ als 24-Stunden-Mittelwert</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li><strong>Feinstaub PM₁</strong>
                  <ul>
                    <li><strong>EU-Grenzwerte:</strong> Derzeit existieren keine spezifischen EU-Grenzwerte für PM₁.</li>
                    <li><strong>WHO-Richtlinien:</strong> Die WHO hat ebenfalls keine spezifischen Richtlinien für PM₁.</li>
                    <li>Obwohl keine spezifischen Grenzwerte für NO und PM₁ festgelegt sind, werden beide Schadstoffe aus gesundheitlicher Sicht als relevant angesehen und in der Luftqualitätsüberwachung berücksichtigt.</li>
                  </ul>
                </li>
              </ul>
            </section>

            <section class="sources">
              <h3>Quellen</h3>
              <ul>
                <li>EU-Richtlinie 2024/2881 über Luftqualität und saubere Luft für Europa</li>
                <li>WHO Global Air Quality Guidelines 2021</li>
                <li>Umweltbundesamt – Luftqualität 2024 (vorläufige Auswertung)</li>
              </ul>
            </section>

            <section class="ui-integration">
              <h3>Integration in die Benutzeroberfläche</h3>
              <ul>
                <li><strong>Dynamische Referenzlinien:</strong> Zeigt die aktuellen und zukünftigen Grenzwerte als Linien im Graphen an, mit der Möglichkeit, zwischen EU- und WHO-Werten umzuschalten.</li>
                <li><strong>Tooltips:</strong> Beim Überfahren der Linien mit der Maus erscheinen Tooltips mit Informationen zum Grenzwert, dem Gültigkeitszeitraum und der Quelle.</li>
                <li><strong>Konfigurierbare Anzeige:</strong> Ermöglicht es den Nutzern, die Anzeige der Grenzwerte je nach Rolle oder Interesse anzupassen (z. B. gesetzlich vorgeschriebene Werte vs. WHO-Empfehlungen).</li>
              </ul>
            </section>
          </section>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
